<template>
  <div>
    <v-btn v-on:click="clicked('From Modal Component')" color="primary">Modal Component</v-btn>
  </div>
</template>;
<script>
import clickMixin from "./clickMixin";
export default {
  name: "Modal",
  mixins: [clickMixin]
};
</script>